import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive } from 'vue'
    
export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
        total: {
            type: Number,
            default: 0
        },
        pageSizes: {
            type: Array,
            default: [10, 20, 30, 40, 50]
        },
        pageSize: {
            type: Number,
            default: 10
        }
    },
  emits: ['pageChange', 'sizeChange'],
  setup(__props, { emit: __emit }) {

    const emits = __emit
    const props = __props
    const pageOptions = reactive({
        page: 1,
        size: props.pageSize
    })
    // 当前页码变化
    const onPageChange = (val,resetPage = true) => {
        if(resetPage) {
            pageOptions.page = 1
        }
        pageOptions.page = val
        document.body.scrollTop = 50
        document.documentElement.scrollTop = 50
        emits('pageChange', pageOptions.page)
    }
    // 每页展示条数变化
    const onSizeChange = (val) => {
        pageOptions.size = val
        emits('sizeChange', pageOptions.size)
        onPageChange(1,false)
    }

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createBlock(_component_el_pagination, {
    onSizeChange: onSizeChange,
    onCurrentChange: onPageChange,
    currentPage: pageOptions.page,
    "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageOptions.page) = $event)),
    "page-size": pageOptions.size,
    "page-sizes": __props.pageSizes,
    layout: "total, sizes, prev, pager, next, jumper",
    total: __props.total
  }, null, 8, ["currentPage", "page-size", "page-sizes", "total"]))
}
}

})